import { createAction, props } from '@ngrx/store';

import { SITE_CONTEXT_ACTIONS } from '../site-context-actions.type';

export const setCountryCode = createAction(
  SITE_CONTEXT_ACTIONS.SET_COUNTRY_CODE,
  props<{
    activeCountryCode: string;
  }>(),
);
